import * as React from "react";
import {Fragment} from "react";
import JobReminderNotification from "../../../model/notification/reminder/JobReminderNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: JobReminderNotification
}

/**
 * Note notification toast body.
 */
const NotificationJobReminderToastBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Note reminder</div>
			<div className={"toast-body"}>
				{props.notification.data.content}
			</div>
		</Fragment>
	);
};

export default NotificationJobReminderToastBody;